import React, { useEffect, useState } from "react";
import { Form, Input, InputNumber, Button, Checkbox, Select } from "antd";
import MetadataEditorModal from "../MetadataEditorModal";

const CreateModalContent = ({
  setOpen,
  createCallback,
  allCrops,
  allPlots,
  allVarieties,
  currentSite,
  greenhouseLabel,
}) => {
  const [form] = Form.useForm();
  const [metadataObj, setMetadataObj] = useState({});
  const [showMetadataEditor, setShowMetadataEditor] = useState(false);

  useEffect(() => {
    form.setFieldsValue({
      name: "",
      is_active: true,
      is_loose: false,
    });
    if (greenhouseLabel === "Glasshouse") {
      form.setFieldsValue({
        plots: [],
      });
    } else {
      form.setFieldsValue({
        crop: null,
        variety_grown: "",
        over_spec_threshold: null,
        under_spec_threshold: null,
        num_of_rows: null,
      });
    }
  }, [greenhouseLabel, form]);

  const onFinish = (values) => {
    if (greenhouseLabel === "Glasshouse") {
      values.variety_grown = "";
      values.over_spec_threshold = 4;
      values.under_spec_threshold = 4;
      values.num_of_rows = 4;
    } else {
      values.plots = [];
    }
    values.metadata = metadataObj || {};
    createCallback(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="flex justify-center">
      <Form
        id="createGreenhouseForm"
        className="max-w-[80%]"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: "name required",
            },
          ]}
        >
          <Input placeholder="Name" />
        </Form.Item>
        <Form.Item
          name="crop"
          label="Crop"
          rules={[
            {
              required: true,
              message: "Please select a crop",
            },
          ]}
        >
          <Select
            placeholder="Select Crop"
            options={allCrops}
            showSearch
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>
        {greenhouseLabel !== "Glasshouse" && (
          <>
            <Form.Item
              name="variety_grown"
              label="Variety"
              rules={[
                {
                  required: true,
                  message: "Variety required",
                },
              ]}
            >
              <Input placeholder="Under Spec" />
            </Form.Item>

            <div className="flex items-center justify-between">
              <Form.Item
                name="over_spec_threshold"
                label="Over Spec"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Input placeholder="Over Spec" />
              </Form.Item>
              <Form.Item
                className="pl-2"
                name="under_spec_threshold"
                label="Under Spec"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Input placeholder="Under Spec" />
              </Form.Item>
            </div>
          </>
        )}
        {greenhouseLabel === "Glasshouse" && (
          <>
            <Form.Item
              name="plots"
              label="Bays"
              rules={[
                {
                  required: true,
                  message: "Please select at least one plots",
                },
              ]}
            >
              <Select
                mode="multiple"
                placeholder="Select Bays"
                options={allPlots}
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item name="varieties" label="Varieties">
              <Select
                mode="multiple"
                placeholder="Select Varieties"
                options={allVarieties}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </>
        )}
        <div className="flex items-center justify-between">
          {greenhouseLabel !== "Glasshouse" && (
            <Form.Item
              className="mr-2"
              name="num_of_rows"
              label="#Rows"
              rules={[
                {
                  required: true,
                  message: "Num_rows required",
                },
              ]}
            >
              <InputNumber />
            </Form.Item>
          )}
          <Form.Item
            name="is_active"
            valuePropName="checked"
            label="Active"
            initialValue={true}
          >
            <Checkbox />
          </Form.Item>
        </div>
        <Form.Item
          name="metadata"
          label="Metadata"
          // rules={[
          //   {
          //     required: true,
          //     message: "metadata required",
          //   },
          // ]}
        >
          {/*<Input.TextArea />*/}
          <Button color="primary" onClick={() => setShowMetadataEditor(true)}>
            Edit Metadata
          </Button>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Create
          </Button>
        </Form.Item>
      </Form>
      <MetadataEditorModal
        name={greenhouseLabel + " Metadata"}
        visible={showMetadataEditor}
        onClose={() => setShowMetadataEditor(false)}
        metadata={metadataObj}
        onUpdateMetadata={(updatedMetadata) => setMetadataObj(updatedMetadata)}
      />
    </div>
  );
};

export default CreateModalContent;
